var _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullScreenButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.62701,
    y: 1.57656,
    width: 12.7034,
    height: 10.69,
    rx: 1.19,
    stroke: "white",
    strokeWidth: 1.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.30151,
    y: 6.95521,
    width: 5.19469,
    height: 3.39815,
    rx: 0.396667,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.566667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreenButton);
export default __webpack_public_path__ + "static/media/fullScreenButton.3aeb5f8b61431dafbd542f58dc107fbf.svg";
export { ForwardRef as ReactComponent };